import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const HorizontalSmallAndLarge = ({ slot }) => {
	const smallSlot = slot[0];
	return (
		<Layout>
			<Slot
				top={smallSlot.type === 'image' ? 0 : 5}
				left={smallSlot.type === 'image' ? 0 : 5}
				width={smallSlot.type === 'image' ? 35 : 25}
				height={90}
				component={slot[0].type}
				data={slot[0].data}
				layout={slot[0].layout}
			/>
			<Slot
				top={5}
				left={35}
				width={60}
				height={90}
				component={slot[1].type}
				data={slot[1].data}
				layout={slot[1].layout}
			/>
		</Layout>
	)
}

HorizontalSmallAndLarge.defaultProps = {
	slot: []
}

HorizontalSmallAndLarge.propTypes = {
	slot: PropTypes.array,
}

export default HorizontalSmallAndLarge
